import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import ArticleGrid from '../article/articleGrid'
import CardBottomButton from '../cardBottomButton'
import ConditionalSliderVideosHeader from '../header/conditionalSliderVideosHeader'

const ScrollableVideoList = ({ selectedData }) => {
  if (!selectedData?.arrayData?.length) return null
  const routeTo = selectedData?.seo?.sSlug || ''
  return (
    <div>
      <div className={`${styles.bodyContainer} position-relative`}>
        <div className="scrollable-wrapper scroll-list">
          <div className="d-inline-flex">
            {selectedData?.arrayData.slice(0, 5).map((item, index) => {
              const thumbnailUrl = item?.aThumbnails?.at(-1)?.sUrl
              return (
                <div
                  key={`video-item-${index}`}
                  style={{
                    width: '280px',
                    flex: '0 0 auto'
                  }}
                >
                  <ArticleGrid
                    isVideo={true}
                    data={item}
                    videoThumbnail={thumbnailUrl}
                    noTitle={true}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <CardBottomButton
        text="See More"
        link={`/${routeTo.includes('cricket/series') ? `${routeTo}/videos` : `${routeTo}?tab=videos`}`}
        internalLink
      />
    </div>
  )
}

ScrollableVideoList.propTypes = {
  selectedData: PropTypes.object
}

function HomePopularVideos({ data = [] }) {
  const sortedData = (data?.length > 1 ? [data?.[1], data?.[0], data?.[2]] : [])?.map(item => ({
    title: item?.sName,
    arrayData: item?.aVideos || [],
    seo: item?.oSeo || {}
  }))

  return (
    <section className={styles.homePopularVideosContainer}>
      <div className={`common-box ${styles.boxBtmPad} p-0`}>
        <ConditionalSliderVideosHeader headerTitle='Popular Videos' data={sortedData}>
          <ScrollableVideoList />
        </ConditionalSliderVideosHeader>
      </div>
    </section>
  )
}

HomePopularVideos.propTypes = {
  data: PropTypes.array
}

export default HomePopularVideos
